const SUPPORTED_URL_PROTOCOLS = new Set(['http:', 'https:', 'mailto:', 'sms:', 'tel:'])
const HAS_SCHEME_REGEX = /^[a-z][a-z\d+.-]*:/i
const HAS_POTENTIAL_SCHEME_SEPARATOR_REGEX = /^[^/?#\s]+:\/\//

const parseUrl = (value: string): URL | undefined => {
  try {
    return new URL(value)
  } catch {
    // Only apply HTTPS fallback for scheme-less values.
    if (HAS_SCHEME_REGEX.test(value) || HAS_POTENTIAL_SCHEME_SEPARATOR_REGEX.test(value)) {
      return undefined
    }

    try {
      return new URL(`https://${value}`)
    } catch {
      return undefined
    }
  }
}

export const sanitizeUrl = (url: string): string => {
  const parsedUrl = parseUrl(url)
  if (!parsedUrl || !SUPPORTED_URL_PROTOCOLS.has(parsedUrl.protocol)) {
    return 'about:blank'
  }

  return url
}

export const validateUrl = (url: string): boolean => {
  if (url === 'https://') {
    return true
  }

  const parsedUrl = parseUrl(url)
  return !!parsedUrl && SUPPORTED_URL_PROTOCOLS.has(parsedUrl.protocol)
}
